export default {
  id: 'push_content',
  title: 'Promote content',
  type: 'Direct',
  canSendToChannel: false,
  relations: [ 'MANY_CONTENT' ],
  description: 'Send a message encouraging colleagues to share content.',
  body: {
    blocks: [
      {
        text: {
          text: '[[INPUT_MESSAGE_TEXT]]',
          type: 'mrkdwn'
        },
        type: 'section'
      },
    ],
  },
  inputs: {
    INPUT_MESSAGE_TEXT: {
      label: 'Message',
      placeholder: 'Share the following content with your network…',
      defaultValue: 'Share the following content with your network to win rewards!',
      type: 'HTML'
    },
  }
};



// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/push/promoteContentShares.js